import React from "react";
import classNames from "classnames";

type PropsTypeButton = {
  disabled?: boolean;
  className: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
} & React.HTMLAttributes<HTMLButtonElement>;

const Button = React.forwardRef<HTMLButtonElement, PropsTypeButton>(
  ({ children, disabled = false, onClick, className, ...props }, ref) => {
    return (
      <button
        className={classNames([className], "btn md:min-w-[9rem]")}
        type='button'
        onClick={onClick}
        disabled={disabled}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  },
);

export default Button;
